import { URL } from '../common/constants';
import { ILinkedin, IRequestMoreData } from '../common/model/linkedin.model';
import { IElementLog } from '../common/model/log.model';
import * as services from '.';
import * as linkedinUtils from '../utils/linkedin.utils';
import { settings } from '../services';

export interface ILinkedinsService {
  fetch(id: string): Promise<ILinkedin>;
  createLog(linkedinLog: IElementLog): Promise<IElementLog>;
  requestMoreData(linkedinMoreData: IRequestMoreData): Promise<void>;
}

class LinkedinsService implements ILinkedinsService {
  public constructor(private httpClient: services.IHttpClient) {

  }

  public async fetch(id: string): Promise<ILinkedin> {
    return linkedinUtils.initDates(await this.httpClient.getCustom<ILinkedin>(`${settings.linkedin}${URL.WEB.LINKEDINS}/${id}`));
  }

  public async createLog(linkedinLog: IElementLog): Promise<IElementLog> {
    return await this.httpClient.postCustom(`${URL.WEB.BASE}${URL.WEB.LINKEDINS}/createLog`, linkedinLog);
  }

  public async requestMoreData(linkedinMoreData: IRequestMoreData): Promise<void> {
    return await this.httpClient.postCustom(`${URL.WEB.BASE}${URL.WEB.LINKEDINS}/requestMoreData`, linkedinMoreData);
  }
}

export const linkedinsService = new LinkedinsService(services.httpClient);
